import React from 'react'

import { Center, Text, Stack, Image } from "@chakra-ui/react"

import logo from './res/logomtvmarche.png'

const Footer = () => {
    return (
        <Center backgroundColor="#e7e7e7" color="#000000"  mt={7} py={5} px={6}>
            <Stack align="center">
                {/* <Image
                    width={[220, 60]}
                    //boxSize="150px"
                    src={logo}
                    alt="Movimento Turismo del Vino - Marche"
                  /> */}
                <Text align="center">© 2021 Una Rosa per Maria - Monastero WiFi.
                <br /><a href="https://www.iubenda.com/privacy-policy/10322591"><b>Privacy Policy</b></a> - <a href="https://www.iubenda.com/privacy-policy/10322591/cookie-policy"><b>Cookie Policy</b></a>
                <br /></Text>
            </Stack>
        </Center>
    )
}

export default Footer
